import { render, staticRenderFns } from "./DownloadImageButton.vue?vue&type=template&id=029ed9f0&"
import script from "./DownloadImageButton.vue?vue&type=script&lang=js&"
export * from "./DownloadImageButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports